import { useTranslation } from 'react-i18next';

import {
  containerStyle,
  contentStyle,
  textContainerStyle,
  textStyle,
  subTextStyle,
  benefitStyle,
  noteContainerStyle,
  noteTextStyle
} from './styles';

import CheckShape from '@/components/common/svg/shapes/CheckShape.tsx';
import { MainButton } from '@/components/common/MainButton/MainButton.tsx';
import { SystemModalContainer } from '@/components/common/SystemModal/SystemModal.tsx';
import InfoShape from '@/components/common/svg/shapes/InfoShape.tsx';

type UnlockBonusesPopupProps = {
  handleClose: () => void;
};

const UnlockBonusesPopup = ({ handleClose }: UnlockBonusesPopupProps) => {
  const { t } = useTranslation();

  return (
    <SystemModalContainer headerTitle="" handleClose={handleClose}>
      <div style={containerStyle}>
        <div style={contentStyle}>
          <div style={textContainerStyle}>
            <p style={textStyle}>{t('earn.unlock_bonuses_popup.header')}</p>
            <p style={subTextStyle}>
              {t('earn.unlock_bonuses_popup.subheader')}
            </p>
            <div style={benefitStyle}>
              <CheckShape width={20} height={20} strokeColor="#000" />
              {t('earn.unlock_bonuses_popup.add_bio')}
            </div>
            <div style={benefitStyle}>
              <CheckShape width={20} height={20} strokeColor="#000" />
              {t('earn.unlock_bonuses_popup.profile_details')}
            </div>
            <div style={benefitStyle}>
              <CheckShape width={20} height={20} strokeColor="#000" />
              {t('earn.unlock_bonuses_popup.add_2_photos')}
            </div>
            <div style={{ ...noteContainerStyle, marginBottom: '80px' }}>
              <InfoShape width={40} height={40} />
              <p style={noteTextStyle}>
                {t('earn.unlock_bonuses_popup.footer')}
              </p>
            </div>
          </div>
        </div>
        <MainButton
          onClick={handleClose}
          text={t('earn.unlock_bonuses_popup.got_it')}
        />
      </div>
    </SystemModalContainer>
  );
};

export default UnlockBonusesPopup;
